/**
 * Prépare une photo de dégât avant l'envoi : réduite à 1 600 pixels sur son plus grand côté et
 * réenregistrée en JPEG. Assez nette pour voir une rayure, bien plus légère à envoyer depuis le parking ;
 * le serveur reste seul juge du contenu. Si le navigateur ne sait pas lire l'image (HEIC sur certains
 * navigateurs), le fichier d'origine est envoyé tel quel.
 */
export const DAMAGE_PHOTO_SIDE = 1600;
export const DAMAGE_PHOTO_TYPES = ['image/jpeg', 'image/png', 'image/webp', 'image/heic', 'image/heif'];
export const DAMAGE_PHOTO_MAX_BYTES = 10 * 1024 * 1024;
export const MAX_DAMAGE_PHOTOS = 6;

export async function damagePhoto(file: File, side = DAMAGE_PHOTO_SIDE): Promise<Blob> {
  try {
    const bitmap = await createImageBitmap(file);
    const scale = Math.min(1, side / Math.max(bitmap.width, bitmap.height));
    const width = Math.max(1, Math.round(bitmap.width * scale));
    const height = Math.max(1, Math.round(bitmap.height * scale));
    const canvas = document.createElement('canvas');
    canvas.width = width;
    canvas.height = height;
    const context = canvas.getContext('2d');
    if (!context) return file;
    // Fond blanc : une image transparente ne devient pas noire en JPEG.
    context.fillStyle = '#fff';
    context.fillRect(0, 0, width, height);
    context.drawImage(bitmap, 0, 0, width, height);
    bitmap.close?.();
    const blob = await new Promise<Blob | null>((done) => canvas.toBlob(done, 'image/jpeg', 0.85));
    return blob && blob.size < file.size ? blob : file;
  } catch {
    return file;
  }
}

/** Refus d'une photo choisie, ou `null`. */
export function damagePhotoRefusal(file: File): string | null {
  // Certains téléphones ne donnent pas le type d'une photo HEIC : le serveur la contrôle.
  if (file.type && !DAMAGE_PHOTO_TYPES.includes(file.type)) return 'Format non pris en charge : JPEG, PNG, WebP ou HEIC attendu.';
  if (file.size > DAMAGE_PHOTO_MAX_BYTES * 3) return 'Photo trop volumineuse.';
  return null;
}
